export default class FloorSelector {
  constructor(selector) {
    this.selector = selector;
    this.floorSelector = selector.querySelector('.floor-selector');
    this.floors = selector.querySelectorAll('.floor[data-level]');
    this.controls = this.floorSelector.querySelectorAll('button:not(.no-units)');
    
    this.currentFloor = 0;
    this.init();

    return this;
  }

  init() {
    this.setFoundAmount();
    this.controls.forEach((control) => {
      control.addEventListener('click', (e) => {
        const { level } = e.currentTarget.dataset;
        this.setFloor(level);
      });
    });
  }
  
  setFloor(level) {
    const floor = this.getFloor(level);

    this.currentFloor = level;
    this.setActiveFloor();
    this.setActiveControl();
    this.setActiveCarouselItem();

    return floor;
  }

  setActiveCarouselItem() {
    let opslagUnitCarousel = null;

    if (!this.floorCarousel) {
      this.floorCarousel = FloorSelector.getFloorCarousel();
    }

    if (this.floorCarousel && this.floorCarousel.element) {
      opslagUnitCarousel = this.floorCarousel.element.closest('.floor-carousel--opslagunits');

      let itemIndex = this.currentFloor;
  
      if (opslagUnitCarousel) {
        itemIndex = 1 - itemIndex;
      }
  
      this.floorCarousel.selectCell(parseInt(itemIndex, 10));
    }
  }

  setActiveFloor() {
    this.floors.forEach((floor) => {
      floor.classList.toggle('active', floor.dataset.level === this.currentFloor);
    });
  }

  setActiveControl() {
    this.controls.forEach((control) => {
      control.classList.toggle('active', control.dataset.level === this.currentFloor);
    });
  }

  getFloor(level) {
    return Array.from(this.floors).find(floor => floor.dataset.level === level);
  }

  static getFloorCarousel() {
    const carouselEl = document.querySelector('.floor-carousel .nectar-flickity');
    const instance = window.Flickity.data(carouselEl);

    return instance;
  }

  setFoundAmount() {
    this.controls.forEach((control) => {
      const { level } = control.dataset;
      const floor = this.getFloor(level);
      const foundAmountEl = control.querySelector('.found-amount');
      const foundUnits = floor.querySelectorAll(`
        .lot-selector-area[data-status="available"][data-filter-match="true"],
        .lot-selector-area[data-status="in-option"][data-filter-match="true"],
        .lot-selector-area[data-status="reserved"][data-filter-match="true"]
      `);

      foundAmountEl.textContent = foundUnits.length;
    });
  }
}
